import { compose } from 'redux';
import PromotionListTrendingOffersHandler from 'components/Content/PromotionListHandler/PromotionListTrendingOffersHandler/PromotionListTrendingOffersHandler';
import { withPromotionListProps } from 'viewModel/content/promotionList/withPromotionListProps';
import { withPromotionListTrendingOffersHandlerProps } from 'viewModel/content/promotionList/promotionListTrendingOffersHandler/withPromotionListTrendingOffersHandlerProps';

const hoc = compose(withPromotionListProps, withPromotionListTrendingOffersHandlerProps);

export default hoc(PromotionListTrendingOffersHandler);
